import { PageType } from "@product/scmp-sdk";

export const pathname = "/podcasts";

export const page = {
  route(query: QueryParameters) {
    return {
      pathname,
      query: { ...query, pageType: PageType.Section },
    };
  },
};
